// UNL's undergraduate majors (#2744). Read on 2026-10-01 from the official
// 2026-2027 Undergraduate Catalog (catalog.unl.edu): the Majors/Areas of
// Study list, with each program's own page giving its college and "Degree
// Offered". Every bachelor's program kept; minors, "Minor Only" entries,
// certificates, the non-degree pre-health, pre-law, pre-veterinary and
// undeclared programs, and graduate programs left out. Quirks: the catalog
// lists the same major under two colleges with a tag, e.g. "Biochemistry
// (CAS)" and "Biochemistry (CASNR)"; the tag is dropped here because the
// group names the college. Degree names are the catalog's own, shortened
// only where it adds graduate degrees to the same line (Architectural
// Studies leads to a Bachelor of Science in Design and then the M.Arch;
// Food Science & Technology also lists the MS and Ph.D.) or joins two with
// a comma. Modern Languages (options in French or German) is a College of
// Arts and Sciences major whose page states no degree, so its degree is
// null. "Women's & Gender Studies" uses a straight apostrophe. Audition,
// portfolio and handicap flags quote UNL's first-year admission page (the
// college file's `requirements` source). The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "university-of-nebraska-lincoln",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UNL's official undergraduate catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates, pre-professional and non-degree programs, and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agricultural Sciences and Natural Resources",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Agricultural Sciences and Natural Resources",
                "url": "https://catalog.unl.edu/undergraduate/agricultural-sciences-natural-resources/"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": "Bachelor of Science in Agribusiness"
                },
                {
                    "name": "Agricultural Economics",
                    "degree": "Bachelor of Science in Agricultural Economics"
                },
                {
                    "name": "Agricultural Leadership, Education and Communication",
                    "degree": "Bachelor of Science in Agricultural Leadership, Education and Communication"
                },
                {
                    "name": "Agricultural Systems Technology",
                    "degree": "Bachelor of Science in Agricultural Systems Technology"
                },
                {
                    "name": "Agronomy",
                    "degree": "Bachelor of Science in Agronomy"
                },
                {
                    "name": "Animal Science",
                    "degree": "Bachelor of Science in Animal Sciences"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science in Biochemistry"
                },
                {
                    "name": "Environmental & Sustainability Studies",
                    "degree": "Bachelor of Science in Environmental & Sustainability Studies"
                },
                {
                    "name": "Environmental Science",
                    "degree": "Bachelor of Science in Environmental Science"
                },
                {
                    "name": "Fisheries & Wildlife",
                    "degree": "Bachelor of Science in Fisheries & Wildlife"
                },
                {
                    "name": "Food Science & Technology",
                    "degree": "Bachelor of Science in Food Science & Technology"
                },
                {
                    "name": "Forensic Science",
                    "degree": "Bachelor of Science in Forensic Science"
                },
                {
                    "name": "Grassland Systems",
                    "degree": "Bachelor of Science in Grassland Systems"
                },
                {
                    "name": "Integrated Science",
                    "degree": "Bachelor of Science in Integrated Science"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Science in Microbiology"
                },
                {
                    "name": "PGA Golf Management",
                    "degree": "Bachelor of Science in PGA Golf Management",
                    "flag": "A 12 handicap is required to enter the program.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Plant & Landscape Systems",
                    "degree": "Bachelor of Science in Plant and Landscape Systems"
                },
                {
                    "name": "Plant Biology",
                    "degree": "Bachelor of Science in Plant Biology"
                },
                {
                    "name": "Regional and Community Forestry",
                    "degree": "Bachelor of Science in Regional and Community Forestry"
                },
                {
                    "name": "Veterinary Science",
                    "degree": "Bachelor of Science in Veterinary and Biomedical Sciences"
                }
            ]
        },
        {
            "name": "College of Architecture",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Architecture",
                "url": "https://catalog.unl.edu/undergraduate/architecture/"
            },
            "note": "Admission to this college asks for more math, and an ACT, SAT or GPA threshold, than UNL admission; students who do not meet it start in the Explore Center.",
            "noteSource": "requirements",
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "Bachelor of Science in Design"
                },
                {
                    "name": "Interior Design",
                    "degree": "Bachelor of Science in Design"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "Bachelor of Landscape Architecture"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Arts and Sciences",
                "url": "https://catalog.unl.edu/undergraduate/arts-sciences/"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Classics & Religious Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Environmental & Sustainability Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Film Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Global Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Individualized Program of Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Modern Languages",
                    "degree": null
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Spanish",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                },
                {
                    "name": "Women's & Gender Studies",
                    "degree": "Bachelor of Arts or Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Business",
                "url": "https://catalog.unl.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Agribusiness",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Business & Law",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Business Analytics",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "International Business",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "Bachelor of Science in Business Administration"
                }
            ]
        },
        {
            "name": "College of Education and Human Sciences",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Education and Human Sciences",
                "url": "https://catalog.unl.edu/undergraduate/education-human-sciences/"
            },
            "majors": [
                {
                    "name": "Communication Sciences & Disorders",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "CYAF: Early Childhood Education in a Mobile Society",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "CYAF: Family & Consumer Sciences Occupational (Grades 6-12)",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "CYAF: Human Development and Family Science",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "CYAF: Inclusive Early Childhood Education (Birth-Grade 3)",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Elementary Education & Special Education (K-6)",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Elementary Education (K-6)",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Elementary Education (K-6) & Early Childhood Education (Age 3-Grade 3)",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Hospitality, Restaurant & Tourism Management",
                    "degree": "Bachelor of Arts in Hospitality, Restaurant & Tourism Management"
                },
                {
                    "name": "Nutrition & Health Sciences: Community Health and Wellness Option",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Nutrition & Health Sciences: Nutrition & Biomedical Sciences Option",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Nutrition & Health Sciences: Nutrition, Exercise & Health Science Option",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Arabic",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Biology",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Business, Marketing & Information Technology",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Chemistry",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Chinese",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: English Language Arts",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: French",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: German",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Japanese",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Latin",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Mathematics",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Physics",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Science",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Secondary English",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Social Studies",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Secondary Education: Spanish",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Special Education (7-12)",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                },
                {
                    "name": "Special Education (K-6)",
                    "degree": "Bachelor of Science in Education & Human Sciences"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Engineering",
                "url": "https://catalog.unl.edu/undergraduate/engineering/"
            },
            "note": "Admission to this college asks for more math, and an ACT, SAT or GPA threshold, than UNL admission; students who do not meet it start in the Explore Center.",
            "noteSource": "requirements",
            "majors": [
                {
                    "name": "Agricultural Engineering",
                    "degree": "Bachelor of Science in Agricultural Engineering"
                },
                {
                    "name": "Architectural Engineering (Omaha)",
                    "degree": "Bachelor of Science in Architectural Engineering"
                },
                {
                    "name": "Biological Systems Engineering",
                    "degree": "Bachelor of Science in Biological Systems Engineering"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science in Chemical Engineering"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science in Civil Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science in Computer Engineering"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science in Computer Science"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "Bachelor of Science in Construction Engineering"
                },
                {
                    "name": "Construction Management",
                    "degree": "Bachelor of Science in Construction Management"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science in Electrical Engineering"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "Bachelor of Science in Environmental Engineering"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science in Mechanical Engineering"
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "Bachelor of Science in Robotics Engineering"
                },
                {
                    "name": "Software Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Journalism and Mass Communications",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Journalism and Mass Communications",
                "url": "https://catalog.unl.edu/undergraduate/journalism-mass-communications/"
            },
            "majors": [
                {
                    "name": "Advertising & Public Relations",
                    "degree": "Bachelor of Journalism"
                },
                {
                    "name": "Broadcasting",
                    "degree": "Bachelor of Journalism"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Journalism"
                },
                {
                    "name": "Sports Media & Communication",
                    "degree": "Bachelor of Journalism"
                }
            ]
        },
        {
            "name": "College of Public Affairs and Community Service",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, College of Public Affairs and Community Service",
                "url": "https://catalog.unl.edu/undergraduate/public-affairs-community-service/"
            },
            "majors": [
                {
                    "name": "Criminology & Criminal Justice",
                    "degree": "Bachelor of Science in Criminology and Criminal Justice"
                }
            ]
        },
        {
            "name": "Hixson-Lied College of Fine and Performing Arts",
            "source": {
                "label": "UNL 2026-2027 Undergraduate Catalog, Hixson-Lied College of Fine and Performing Arts",
                "url": "https://catalog.unl.edu/undergraduate/fine-performing-arts/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "Bachelor of Fine Arts",
                    "flag": "Auditions are required.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts or Bachelor of Fine Arts"
                },
                {
                    "name": "Art History and Criticism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Arts",
                    "flag": "Auditions are required.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Emerging Media Arts",
                    "degree": "Bachelor of Fine Arts",
                    "flag": "An application and a portfolio are required.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Entertainment Design and Production",
                    "degree": "Bachelor of Fine Arts",
                    "flag": "An application and a portfolio are required.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Graphic Arts",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Graphic Design",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts or Bachelor of Music",
                    "flag": "Auditions are required.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music Education"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of Arts"
                }
            ]
        }
    ]
};

export default majors;
